import React from "react";
import "./index.scss";

const CarouselItem = (props) => {
  const classN = props.className ? `carousel-item ${props.className}` : "carousel-item";
  return (
    <div className={classN}>
      <img src={props.img} alt="輪播圖"/>
    </div>
  )
};

class Carousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      updateIndex: null,
      currentClass: 'active',
      updateClass: '',
      lock: null,
      timer: null
    };
    this.clickNext = this.clickNext.bind(this);
    this.clickPrev = this.clickPrev.bind(this);
    this.autoPlay = this.autoPlay.bind(this);
    this.stopPlay = this.stopPlay.bind(this);
  }
  autoPlay() {
    if (this.state.timer) return;
    this.setState({
      timer: setInterval(() => {
        this.clickNext();
      }, 5000)
    });
  }
  stopPlay() {
    clearInterval(this.state.timer);
    this.setState({
      timer: null
    });
  }
  clickNext() {
    if (this.state.lock) return;

    this.setState({
      lock: true
    }, function () {
      this.setState((state, props) => {
        return {
          updateIndex: state.currentIndex < props.pictures.length - 1 ? state.currentIndex + 1 : 0,
          updateClass: 'carousel-item-next'
        }
      }, function () {
        setTimeout(() => {
          this.setState({
            updateClass: 'carousel-item-next carousel-item-left',
            currentClass: 'active carousel-item-left'
          }, function () {
            setTimeout(() => {
              this.setState(state => {
                return {
                  currentIndex: state.updateIndex,
                  updateIndex: null,
                  currentClass: 'active',
                  updateClass: ''
                }
              }, function () {
                this.setState({
                  lock: null
                })
              });
            }, 600);
          })
        }, 50);
      })
    });

  }
  clickPrev() {
    if (this.state.lock) return;
    this.setState({
      lock: true
    }, function () {
      this.setState((state, props) => {
        return {
          updateIndex: state.currentIndex > 0 ? state.currentIndex - 1 : props.pictures.length - 1,
          updateClass: 'carousel-item-prev'
        }
      }, function () {
        setTimeout(() => {
          this.setState({
            updateClass: 'carousel-item-prev carousel-item-right',
            currentClass: 'active carousel-item-right'
          }, function () {
            setTimeout(() => {
              this.setState(state => {
                return {
                  currentIndex: state.updateIndex,
                  updateIndex: null,
                  currentClass: 'active',
                  updateClass: ''
                }
              }, function () {
                this.setState({
                  lock: null
                })
              });
            }, 600);
          })
        }, 50);
      })
    });
  }
  componentDidMount() {
    this.autoPlay();
  }
  componentWillUnmount() {
    this.stopPlay();
  }
  render() {
    const pictures = this.props.pictures;
    const _group = pictures.map((img, i) => {
      let _className = "";
      if (i === this.state.currentIndex) {
        _className = this.state.currentClass;
      } else if (i === this.state.updateIndex) {
        _className = this.state.updateClass;
      }
      return <CarouselItem key={i} img={img} className={_className}/>
    });
    return (
      <div className="carousel carousel-fade" onMouseEnter={this.stopPlay} onMouseLeave={this.autoPlay}>
        <div className="carousel-inner">
          {_group}
        </div>
        <div className="carousel-control">
          <button className="carousel-control-btn" onClick={() => this.clickPrev()}>
            <i className="fa fa-chevron-left"/>
          </button>
          <button className="carousel-control-btn" onClick={()=> this.clickNext()}>
            <i className="fa fa-chevron-right"/>
          </button>
        </div>
      </div>
    )
  }
}

export default Carousel;
